// ============================================================
// SALT — Guest CTA Component
// Shown at bottom of dashboard for unauthenticated users
// ============================================================

import React from 'react';

interface GuestCtaProps {
  onSignIn: () => void;
}

const GuestCta: React.FC<GuestCtaProps> = ({ onSignIn }) => (
  <div className="sl-guest-cta">
    <div className="sl-guest-cta-inner">
      <h3 className="sl-guest-cta-title">Ready to compete?</h3>
      <p className="sl-guest-cta-text">
        Sign in or create an account to form a team and start climbing the ladder.
      </p>
      <button className="sl-btn sl-btn-outline" onClick={onSignIn}>
        Sign In / Register
      </button>
    </div>
  </div>
);

export default GuestCta;